const mediaItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=A%20video%20thumbnail%20style%20image%20showing%20a%20dramatic%20scene%20from%20a%20Chinese%20TV%20series%2C%20warm%20cinematic%20lighting%2C%20emotional%20moment%2C%20professional%20photography%2C%20clean%20background&width=800&height=500&seq=media-01&orientation=landscape',
    title: '红桃视频 · 年度热播大剧精选',
    duration: '更新至48集',
    platform: '红桃视频',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20video%20thumbnail%20style%20image%20showing%20a%20mystery%20scene%20with%20dark%20warm%20tones%2C%20suspenseful%20atmosphere%2C%20cinematic%20composition%2C%20dramatic%20lighting%2C%20professional%20photography&width=800&height=500&seq=media-02&orientation=landscape',
    title: '樱桃视频 · 悬疑剧场强档热映',
    duration: '全24集',
    platform: '樱桃视频',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20video%20thumbnail%20style%20image%20showing%20a%20trendy%20short%20drama%20scene%2C%20vibrant%20warm%20colors%2C%20youthful%20urban%20setting%2C%20cinematic%20lighting%2C%20stylish%20modern%20composition&width=800&height=500&seq=media-03&orientation=landscape',
    title: '茄子视频 · 热门短剧每日连载',
    duration: '日更中',
    platform: '茄子视频',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20video%20thumbnail%20style%20image%20showing%20a%20variety%20show%20scene%20with%20bright%20cheerful%20atmosphere%2C%20entertainment%20vibe%2C%20colorful%20warm%20lighting%2C%20professional%20photography&width=800&height=500&seq=media-04&orientation=landscape',
    title: '糖心视频 · 爆款综艺精彩看点',
    duration: '更新至12期',
    platform: '糖心视频',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20video%20thumbnail%20style%20image%20showing%20a%20historical%20costume%20drama%20scene%2C%20elegant%20traditional%20aesthetic%2C%20warm%20amber%20lighting%2C%20cinematic%20composition%2C%20professional%20photography&width=800&height=500&seq=media-05&orientation=landscape',
    title: '红桃视频 · 古装巨制震撼上线',
    duration: '全40集',
    platform: '红桃视频',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-900 mb-3">
            热门剧集
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
            各大视频平台热门内容速览，点击跳转观看
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {mediaItems.slice(0, 3).map((item, i) => (
            <div
              key={i}
              className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="aspect-[16/10] overflow-hidden bg-background-200 relative">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors duration-300 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-background-50/90 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <i className="ri-play-fill text-2xl text-primary-500 ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 px-2.5 py-1 rounded-lg bg-black/60 text-xs font-medium text-background-50 whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <span className="text-xs text-accent-600 font-medium whitespace-nowrap">{item.platform}</span>
                <h3 className="text-sm font-bold text-foreground-900 mt-1 line-clamp-2">{item.title}</h3>
              </div>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {mediaItems.slice(3).map((item, i) => (
            <div
              key={i + 3}
              className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 flex flex-col sm:flex-row"
            >
              <div className="aspect-[16/10] sm:w-[200px] sm:flex-shrink-0 overflow-hidden bg-background-200 relative">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors duration-300 flex items-center justify-center">
                  <div className="w-10 h-10 rounded-full bg-background-50/90 flex items-center justify-center">
                    <i className="ri-play-fill text-lg text-primary-500 ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded-md bg-black/60 text-xs font-medium text-background-50 whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <div className="p-4 flex flex-col justify-center">
                <span className="text-xs text-accent-600 font-medium whitespace-nowrap">{item.platform}</span>
                <h3 className="text-sm font-bold text-foreground-900 mt-1">{item.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}